<template>
    <table
        class="table"
        :class="{ 'table-wide': layoutOptions.layout_style === 'none'}"
    >
        <thead>
    <!--        <tr class="h-1" >-->
    <!--            <th :colspan="5">-->
    <!--                <progress-bar v-if="loadingFiltersAndPaginationData" />-->
    <!--            </th>-->
    <!--        </tr>-->
            <tr>
                <th scope="col">
                    {{ portalTranslationSettings.referral || 'Referral' }}
                </th>
                <th scope="col">
                    {{ portalTranslationSettings.action || 'Action' }}
                </th>
            <th scope="col">
                {{ portalTranslationSettings.reward || 'Reward' }}
                </th>
                <th scope="col">
                    {{ portalTranslationSettings.status || 'Status' }}
                </th>
                <th scope="col">
                    {{ portalTranslationSettings.date || 'Date' }}
                </th>
            </tr>
            <tr class="h-1"/>
        </thead>
        <tbody>
        <tr
            v-for="referral in recentActivities"
            class="hover:bg-gray-100 hover:bg-opacity-50"
        >
            <td class="whitespace-nowrap">
                <div v-if="referral['multi_tier_affiliate_commission']" class="font-medium group-hover:underline" :class="'group-hover:text-' + isCustomColor(layoutOptions.link_color) ? 'custom-link' : layoutOptions.link_color">
                    Referred Partner reward
                </div>
                <a
                    v-else-if="referral['email'] || referral['customer_full_name']"
                    :href="getReferralActivityRoute(referral)"
                    class="block group"
                >
                    <div
                        class="font-medium group-hover:underline"
                        :class="'group-hover:text-' + isCustomColor(layoutOptions.link_color) ? 'custom-link' : layoutOptions.link_color"
                    >
                        {{ referral['customer_full_name'] }}
                    </div>
                    <span v-if="layoutOptions.showCustomerInfo" class="opacity-60">{{ referral['email'] }}</span>
                </a>
                <template v-else>-</template>
            </td>


            <td class="whitespace-nowrap">
                <referral-action :action="referral['action']" :text-color="layoutOptions.text_color"/>
            </td>
            <td class="font-medium whitespace-nowrap">
                <tooltip v-if="referral['reward_commission_description']" :content="referral['reward_commission_description']" class="cursor-pointer">
                    {{ referral['currency_amount'] || ' - ' }}
                </tooltip>
                <div v-else>
                    {{ referral['currency_amount'] || ' - ' }}
                </div>
            </td>
            <td class="font-medium whitespace-nowrap">
                <referral-status :status="referral['status']" :archived="referral['is_archived']" :activity="referral" />
            </td>
            <td class="whitespace-nowrap">
                <time
                    class="opacity-60"
                    :datetime="referral['date']"
                >
                    {{ referral['parsed_date_time'] }}
                </time>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import useFiltersAndPagination from "../../../../state/common/filters-and-pagination";
import filtersAndPaginationData from "../../../../composables/common/filter-and-pagination-data";
import useTranslationSettings from "../../../../state/portal/portal-translation-settings";
import {isCustomColor} from "../../../../helpers/common";
import ReferralAction from "./ReferralAction";
import ReferralStatus from "../../../common/ReferralStatus";
import ProgressBar from "../../../../elements/ProgressBar";

export default {
    name: "ReferralDataTable",
    components: {
        ProgressBar,
        ReferralAction,
        ReferralStatus
    },
    props: ['recentActivities'],
    setup() {
        const {layoutOptions} = useFiltersAndPagination()
        const {loadingFiltersAndPaginationData} = filtersAndPaginationData()
        const {portalTranslationSettings} = useTranslationSettings()

        const getReferralActivityRoute = (referral) => {
            if (referral['customer_id']) {
                return route('partners.referral', referral['customer_id'])
            }
            return '#'
        }

        return {layoutOptions, loadingFiltersAndPaginationData, portalTranslationSettings, getReferralActivityRoute}
    },
    methods: {
        isCustomColor
    }
}
</script>
